import { render, staticRenderFns } from "./ProjectImportWizard.vue?vue&type=template&id=22f50b6f"
import script from "./ProjectImportWizard.vue?vue&type=script&lang=js"
export * from "./ProjectImportWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports